import { gsap, SplitText } from '../global/gsap';

const initInfo = (element) => {
    document.fonts.ready.then(() => {
        const html = document.querySelector('.js-html');
        const infoToggle = document.querySelector('.js-info-button');
        const stopScrollingClass = 'stop-scrolling';
        const isActiveClass = 'show-info';
        let showInfo = false;

        const people = element.querySelectorAll('.info__person');
        const thumbs = element.querySelector('.info__thumbnails');
        const textP = element.querySelector('.info__desc p');
        const links = element.querySelectorAll('.info__links a');
        const ticker = element.querySelectorAll('.info__ticker');

        let split;
        let infoTl;
        let lines;

        // 1. Function to create the split and animation
        function createAnimation() {
            // Revert previous instance if it exists
            if (split) {
                split.revert();
            }

            // Split the text
            split = new SplitText(textP, {
                type: 'lines',
                mask: 'lines',
                linesClass: 'line++'
            });

            lines = split.lines;

            // Kill old timeline if it exists
            if (infoTl) {
                infoTl.kill();
            }

            if (showInfo) {
                showInfo = false;
                html.classList.remove(stopScrollingClass, isActiveClass);
            }

            // Create new timeline
            infoTl = gsap.timeline({
                paused: true,
                defaults: {
                    delay: 0.3,
                    duration: 0.5,
                    overwrite: true
                }
            });

            infoTl.addLabel('start');

            // Create new animation
            infoTl.fromTo(people, {
                opacity: 0
            }, {
                opacity: 1,
                stagger: 0.1,
            }, 'start').fromTo(thumbs, {
                opacity: 0
            }, {
                duration: 0.33,
                opacity: 1,
            }, 'start').fromTo(lines, {
                opacity: 0,
                y: '75%'
            }, {
                opacity: 1,
                y: 0,
                stagger: 0.1
            }, 'start').fromTo(links, {
                opacity: 0
            }, {
                opacity: 1,
                stagger: 0.1
            }, 'start')
                .fromTo(ticker, {
                    opacity: 0,
                    y: 15
                }, {
                    opacity: 1,
                    y: 0
                }, 'start');
        }

        createAnimation();

        window.addEventListener('resize', createAnimation);

        const thumbMedia = element.querySelectorAll('.js-thumbnail');
        const n = thumbMedia.length;
        const hold = 2;
        const fade = 0.5;

        gsap.set(thumbMedia, { opacity: 0 });
        gsap.set(thumbMedia[0], { opacity: 1 });

        const mediaTl = gsap.timeline({ repeat: -1, paused: true });

        thumbMedia.forEach((media, i) => {
            const t = (i + 1) * hold;
            const next = thumbMedia[(i + 1) % n];
            mediaTl.to(media, { opacity: 0, duration: fade }, t);
            mediaTl.to(next, { opacity: 1, duration: fade }, t);
        });

        infoToggle.addEventListener('click', (event) => {
            event.preventDefault();
            showInfo = !showInfo;

            if (showInfo) {
                infoTl.play(0);
                mediaTl.play();
                html.classList.add(stopScrollingClass, isActiveClass);
            } else {
                infoTl.pause().totalProgress(1);
                mediaTl.pause();
                html.classList.remove(stopScrollingClass, isActiveClass);
            }
        });
    });
};

export { initInfo as default };
